import { useCallback } from 'react'
import ButtonModalSortList, { ItemSortFunction } from '../../../../../../../baseComponents/Sorts/ButtonModalSortList'
import { BaseButtonModalSortListProps } from '../../../../../../../baseComponents/Sorts/ButtonModalSortList/types'
import { twinFetchPostText } from '../../../../../../../utils/globals/data'

interface SortSpecificPriceRulesProps extends BaseButtonModalSortListProps { }

const SortSpecificPriceRules: React.FC<SortSpecificPriceRulesProps> = ({ ...rest }) => {
    const { updateOrder } = useSortSpecificPriceRulesLogic()
    return (
        <ButtonModalSortList updateData={updateOrder} getDataFrom='/api/app/product/specificPrice/getAllSpecificPriceRules' {...rest} />
    )
}

const useSortSpecificPriceRulesLogic = () => {
    const updateOrder: ItemSortFunction = useCallback(async (data) => {
        const resp = await twinFetchPostText('/api/app/product/specificPrice/updateSpecificPriceRuleOrder', { specificPriceRules: data })
        if (resp) {
            return true
        }
        return false
    }, [])

    return { updateOrder }
}

export default SortSpecificPriceRules